// extracted by mini-css-extract-plugin
module.exports = {"TextArea":"TextArea_TextArea__1xbbg","disabled":"TextArea_disabled__QvuF1"};